import { render } from "./ProjectsStatistics.vue?vue&type=template&id=219e3588&scoped=true"
import script from "./ProjectsStatistics.vue?vue&type=script&lang=js"
export * from "./ProjectsStatistics.vue?vue&type=script&lang=js"

import "./ProjectsStatistics.vue?vue&type=style&index=0&id=219e3588&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219e3588"]])

export default __exports__